import React, { Component } from 'react';
import { css } from 'emotion';
import { ButtonGroup, Button } from 'reactstrap';

class EirColourSelector extends Component {
  constructor(props) {
    super(props);
  }

  handleColourSelected = colourOption => {
    this.props.onColourSelected && this.props.onColourSelected(colourOption);
  };

  isSelectedColour = colourOption => {
    return (
      this.props.selectedColour.colour == colourOption.colour &&
      this.props.selectedColour.name == colourOption.name
    );
  };

  render() {
    return (
      <ButtonGroup className={'colour-selector ' + (this.props.large ? 'large' : 'small')} >
        {this.props.colourOptions.map((colourOption, index) => (
          <div key={index + colourOption.colour} className="d-flex flex-column justify-content-start align-items-center">            
              {colourOption.colour.includes('#')?
              <div className='d-inline-grid btn-selected' style={this.isSelectedColour(colourOption)?(this.props.selectedColour.colour=='#ffffff' || this.props.selectedColour.colour=='#FFFFFF'?{borderColor:'#F3F3F3'}:{borderColor:this.props.selectedColour.colour}): null}>
              <Button
                onClick={() => this.handleColourSelected(colourOption)}
                active={this.isSelectedColour(colourOption)}
                className={(colourOption.colour == '#ffffff' || colourOption.colour == '#FFFFFF')?(css`background-color: #F3F3F3 !important; `) :(css`background-color: ${colourOption.colour} !important; &:hover {background-color: ${colourOption.colour} !important; `)}
                value={colourOption.name}
              />
              </div>:
              <div className='d-inline-grid btn-selected' style={this.isSelectedColour(colourOption)?(this.props.selectedColour.colour=='ffffff' || this.props.selectedColour.colour=='FFFFFF' || this.props.selectedColour.colour=='fff'?{borderColor:'#F3F3F3'}:{borderColor:'#' + this.props.selectedColour.colour}): null}>
              <Button
              onClick={() => this.handleColourSelected(colourOption)}
              active={this.isSelectedColour(colourOption)}
              className={(colourOption.colour == 'ffffff' || colourOption.colour == 'FFFFFF' || colourOption.colour=='fff')?(css`background-color: #F3F3F3 !important; `) :(css`background-color: #${colourOption.colour} !important; &:hover {background-color: #${colourOption.colour} !important; `)}
              value={colourOption.name}
            />
            </div>}
            <div className="colour-selected text-center mt-1 colour-name-selector">
              {colourOption.name}
            </div>

          </div>
        ))}
      </ButtonGroup>
    );
  }
}

export default EirColourSelector;
